export const USE_MARKETPLACE_DEMO = true;
export const USE_CAL_BOOKING_EXPERIENCE = true;
export const CAL_BOOKING_URL = "https://cal.com/willem-berry-mandateos";
export const CAL_BOOKING_EMBED_URL = `${CAL_BOOKING_URL}?embed=1&theme=dark&layout=month_view`;
